import { useI18n } from '../../lib/i18n';
import { Button } from '../ui/Button';

interface FallbackWarningBannerProps {
  onConfigureClick: () => void;
}

export function FallbackWarningBanner({ onConfigureClick }: FallbackWarningBannerProps) {
  const { t } = useI18n();

  return (
    <div className="mb-6 rounded-xl border border-amber-300 bg-amber-50/80 p-4 text-amber-900 shadow-sm dark:border-amber-700/50 dark:bg-amber-950/40 dark:text-amber-200">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-3">
          <div className="mt-0.5 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-amber-200/80 text-amber-800 dark:bg-amber-800/60 dark:text-amber-200">
            <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
            </svg>
          </div>
          <div>
            <h4 className="text-sm font-bold">{t('ai.banner.fallbackTitle')}</h4>
            <p className="mt-0.5 text-xs text-amber-800/90 dark:text-amber-300/90">
              {t('ai.banner.fallbackDesc')}
            </p>
          </div>
        </div>
        <div className="flex-shrink-0">
          <Button
            size="sm"
            variant="secondary"
            onClick={onConfigureClick}
            className="border-amber-300 bg-white text-amber-900 hover:bg-amber-100 dark:border-amber-700 dark:bg-amber-900 dark:text-amber-100 dark:hover:bg-amber-800"
          >
            {t('ai.banner.configureProviders')}
          </Button>
        </div>
      </div>
    </div>
  );
}
